module.exports = __webpack_public_path__ + "img/找充电桩.854b0c92.png";